// src/services/symbolService.js
//
// All symbol-related API calls live here.
// Base URL comes from .env → REACT_APP_URL
// So you never hardcode http://127.0.0.1:8000 anywhere else.

const BASE = process.env.REACT_APP_URL;
// const BASE = "http://127.0.0.1:8000";


/**
 * Fetch ALL active symbols (called once on app start).
 * Returns an array of symbol objects.  
 */
export async function fetchAllSymbols() {
    console.log("Fetching all symbols from API...");
    const headers = new Headers({
        "Content-Type": "application/json",
        "x-api-key": process.env.REACT_APP_API_KEY,
        "ngrok-skip-browser-warning": "true",

    });
  const params = new URLSearchParams({
    is_active: "True",
    // is_shariah: "",
    sector_code: "",
    search: "",
  });
  console.log(`Constructed URL: ${BASE}/api/symbols/?${params}`);

  const res = await fetch(`${BASE}/api/symbols/?${params}`

    , {
  method: "GET",
  headers: headers,
}
  );
//   print the response status for debugging
  console.log(`fetchAllSymbols response status: ${res}`);
  if (!res.ok) throw new Error(`Symbols API error: ${res.status}`);
  const data = await res.json();
  // Handle both { results: [...] } and plain array
  return Array.isArray(data) ? data : data.results || [];
}

/**
 * Fetch symbols filtered by search + sector (optional, for server-side search).
 * You probably won't need this once you switch to local filtering.
 */
export async function searchSymbols(search = "", sectorCode = "") {
  const params = new URLSearchParams({
    is_active: "True",
    is_shariah: "",
    sector_code: sectorCode,
    search,
  });
  const res = await fetch(`${BASE}/api/symbols/?${params}`);
  if (!res.ok) throw new Error(`Symbols API error: ${res.status}`);
  const data = await res.json();
  return Array.isArray(data) ? data : data.results || [];
}

/**
 * Fetch detail for a single symbol (for the trading dashboard page).
 * Usage: fetchSymbolDetail("PPL")
 */
export async function fetchSymbolDetail(symbol) {
  const res = await fetch(`${BASE}/api/symbols/${symbol}/`);
  if (!res.ok) throw new Error(`Symbol detail error: ${res.status}`);
  return res.json();
}